module.exports = __webpack_public_path__ + "media/images/ac_templates/201/htchr-6aa7ad893dec3d126d5582456b228395.jpg";